import { useCallback } from 'react';

import useLocalStorage from './useLocalStorage';

export const NAVIGATION_LAYOUT_STORAGE_KEY = 'adminNavigationLayout';

export const NAVIGATION_LAYOUTS = {
  HEADER: 'header',
  SIDEBAR: 'sidebar',
} as const;

export type NavigationLayout = (typeof NAVIGATION_LAYOUTS)[keyof typeof NAVIGATION_LAYOUTS];

const DEFAULT_NAVIGATION_LAYOUT = NAVIGATION_LAYOUTS.HEADER;

export function isNavigationLayout(value: unknown): value is NavigationLayout {
  return value === NAVIGATION_LAYOUTS.HEADER || value === NAVIGATION_LAYOUTS.SIDEBAR;
}

export default function useNavigationLayoutPreference() {
  const [storedLayout, setStoredLayout] = useLocalStorage(NAVIGATION_LAYOUT_STORAGE_KEY, DEFAULT_NAVIGATION_LAYOUT);

  const navigationLayout = isNavigationLayout(storedLayout) ? storedLayout : DEFAULT_NAVIGATION_LAYOUT;

  const setNavigationLayout = useCallback(
    (layout: NavigationLayout) => {
      setStoredLayout(layout);
    },
    [setStoredLayout],
  );

  return [navigationLayout, setNavigationLayout] as const;
}
